import type { DashCard } from './DashCard.model'
import { fetchUtils } from '../../utils/fetchUtils'
import type { DashCardParams } from '../DashboardPage.model'
import { convertUnixToUtcEnd, convertUnixToUtcStart } from '../../types/datepicker'

export async function fetchDashCardData(
	cardId: string,
	cardQueryData: DashCardParams
): Promise<DashCard> {
	// conversion of unix to utc timezone unix
	const mainFrom = convertUnixToUtcStart(cardQueryData.mainTimeframe[0]).unix()
	const mainTo = convertUnixToUtcEnd(cardQueryData.mainTimeframe[1]).unix()
	const prevFrom = convertUnixToUtcStart(cardQueryData.prevTimeframe[0]).unix()
	const prevTo = convertUnixToUtcEnd(cardQueryData.prevTimeframe[1]).unix()

	return fetchUtils.post(
		'/api/dashboard/card',
		{
			cardId: cardId,
			userId: cardQueryData.userId,
			main: {
				from: mainFrom,
				to: mainTo
			},
			comp: {
				from: prevFrom,
				to: prevTo
			}
		},
		false
	)
}
